import React from 'react'; // Eski React sürümleri için gereklidir
import { Routes, Route, useLocation, BrowserRouter } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import AdminPanel from './pages/AdminPanel';
import PrivateRoute from './PrivateRoute';
import WhatsAppIcon from './components/WhatsappIcon'; // WhatsApp ikonu bileşeni
import Login from './pages/Login';
import ServiceDetail from './pages/ServiceDetail';
import ProjectDetail from './pages/ProjectDetail';

function RouterPage() {
  const location = useLocation();

  const isAdminPage = location.pathname === '/admin' || location.pathname === '/adminpanel';
  const isHomePage = location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col">
      {!isAdminPage && (
        <div className="top-0 left-0 right-0 z-50">
          <Navbar />
        </div>
      )}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/hizmetlerimiz" element={<Services />} />
          <Route path="/referanslarimiz" element={<Projects />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/services/:title" element={<ServiceDetail />} />
          <Route path="/projects/:title" element={<ProjectDetail />} />
          <Route path="/admin" element={<Login />} />
          <Route
            path="/adminpanel"
            element={
              <PrivateRoute>
                <AdminPanel />
              </PrivateRoute>
            }
          />
        </Routes>
      </main>
      {!isAdminPage && <WhatsAppIcon />}
      {!isAdminPage && !isHomePage && <Footer />}
    </div>
  );
}


export default function App() {
    return (
      <BrowserRouter>
      <RouterPage />
      </BrowserRouter>
    );
  }
